export default {"src":"/_next/static/media/mona.d3600359.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};